// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { editArticle, getArticleById } from "../../../features/article";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const EditArticle = () => {
  const { id } = useParams<{ id: string }>();
  const { article, status } = useSelector((state: any) => state.article);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    sub_title: "",
    description: "",
    status: "Draft", // Default status
    thumbnail_img: null,
    is_home:false,
    location_name:""
  });

  useEffect(() => {
    // Fetch the article data by ID
    dispatch(getArticleById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (status && article?.data) {
      const data = article.data;
      setFormData({
        title: data.title ,
        sub_title: data.sub_title, 
        description: data.description,
        status: data.status || "Draft", // Default status
        thumbnail_img: data.thumbnail_img || null, 
        is_home:data.is_home,
    location_name:data.location_name
      });
    }
  }, [status, article]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value ,checked} = e.target;
    console.log(name, value,checked,typeof(value),'name, value');
    
    setFormData((prev) => ({
      ...prev,
      [name]:name ==='is_home'?checked: value,
    }));
  };

  const handleThumbnailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        thumbnail_img: e.target.files[0], // Handle thumbnail image change
      }));
    }
  };

  const handleSubmit = () => {
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined) {
        if(key==='is_home'){
          formDataFinal.append(key, value === 'on'?true:false); 
        }else{
        formDataFinal.append(key, value);
        }
      }
    });
    dispatch(editArticle({ id, updatedArticle: formDataFinal }))
      .then((res: any) => {
        toast.success(res.payload.message); // Assuming you have a toast function
        navigate("/article"); // Redirect to articles page
      })
      .catch((err: any) => {
        console.error(err, "error");
        toast.error("An error occurred while updating the article.");
      });
  };
console.log(formData,'formDaraedit');

  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      {/* Form Container */}
      <SoftBox width="100%" maxWidth="400px" >
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Edit Article
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Title Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="title"
              placeholder="Enter the article title"
              value={formData.title}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Sub-title Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Sub-title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="sub_title"
              placeholder="Enter the sub-title"
              value={formData.sub_title}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Description Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Description
              </SoftTypography>
            </SoftBox>
            <CKEditor
                      editor={ ClassicEditor }
                      data={formData.description}
                      onInit={ editor => {
                          // You can store the "editor" and use when it is needed.
                          console.log( 'Editor is ready to use!', editor );
                      } }
                      onChange={ ( event, editor ) => {
                          const data = editor.getData();
                          console.log( { event, editor, data } ,'onCHnagwe');

                          setFormData((prev) => ({
                            ...prev,
                            ['description']: data,
                          }));
                      } }
                      // onBlur={ ( event, editor ) => {
                      //     console.log( 'Blur.', editor );
                      // } }
                      // onFocus={ ( event, editor ) => {
                      //     console.log( 'Focus.', editor );
                      // } }
                  />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Location Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="location_name"
              placeholder="Enter the location name"
              value={formData.location_name}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2} display="flex" alignItems="center" >
            <SoftBox mb={1} ml={0.5} mr={1}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
              Is Home
              </SoftTypography>
            </SoftBox>
            <input
      
                type="checkbox"
                name="is_home"
                checked={formData.is_home}
                onChange={handleChange}
                sx={{ border: 'none' }}
    />
          </SoftBox>

          {/* Status Dropdown */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Status
              </SoftTypography>
            </SoftBox>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="Draft">Draft</option>
              <option value="Published">Published</option>
            </select>
          </SoftBox>

          {/* Thumbnail Image Upload */}
<SoftBox mb={2}>
  <SoftBox mb={1} ml={0.5}>
    <SoftTypography component="label" variant="caption" fontWeight="bold">
      Thumbnail Image
    </SoftTypography>
  </SoftBox>
  {/* If there's a base64 image, show it */}
  {formData.thumbnail_img && (
    <img
      src={`${formData.thumbnail_img}`}  // Assuming it's JPEG, adjust if it's a different format
      alt="Thumbnail"
      style={{ width: "150px", height: "150px", borderRadius: "5px" }}
    />
  )}
  {/* File input for changing the thumbnail */}
  <input
    type="file"
    name="thumbnail_img"
    onChange={handleThumbnailChange}
    style={{ width: "100%" }}
  />
</SoftBox>


          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="info" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditArticle;
